export type GroupSelectOption = { label: string; values: string[] }

/**
 * Determine whether every value in a group is present in the current selections
 * @param group
 * @param currentSelections
 * @returns Whether the group should be rendered as fully selected
 */
export const isGroupSelected = (
  group: GroupSelectOption,
  currentSelections: string[] | string | null | undefined
): boolean => {
  if (!Array.isArray(currentSelections)) {
    return false
  }
  return group.values.every((v) => currentSelections.includes(v))
}

/**
 * Add or remove a group's values from the current selections
 * @param group
 * @param currentSelections
 * @param isNewlySelected
 * @returns Updated selections array with the group's values added or removed
 */
export const toggleGroupSelection = (
  group: GroupSelectOption,
  currentSelections: string[],
  isNewlySelected: boolean
): string[] =>
  isNewlySelected
    ? [...new Set([...currentSelections, ...group.values])]
    : currentSelections.filter((val) => !group.values.includes(val))
